import { openMailto } from "@/utils/mailto";
import emergencyIcon from "@assets/icons/emergencyIcon.svg";
import { HeroButton } from "../components/button";
import bulletPoint from "@assets/icons/bulletPoint.svg";
import PartnerHeader from "../components/header";
import infoIcon from "@assets/images/Frame-7.svg";
import heroImage from "@assets/images/developer&ownerHero.svg";
import macbook from "@assets/images/macbook.svg";
import documentIcon from "@assets/images/document.svg";
import downloadIcon from "@assets/images/download.svg";
import buildingIcon from "@assets/icons/building-2-fill.svg";
import mailIcon from "@assets/icons/mail-fill.svg";
import phoneIcon from "@assets/icons/phone-fill.svg";

import {
  serviceCards,
  Benefits,
  Lifecycles,
  projectTypes,
  relationship,
  performances,
  developerToolkit,
} from "../data";
import BenefitsAccordion from "../components/BenefitsAccordion";
import relationshpImage from "@assets/images/relationshpImage.svg";
import RequestProposalForm from "../components/requestProposalForm";
import Contact from "../components/contact";

const heroData = {
  title: "Comprehensive Gas Solutions for Developers, Owners & Communities",
  description:
    "GAZ provides end to end engineering, installation, commissioning, billing, and maintenance services for residential towers, mixed-use developments, communities, retail centers, and hospitality projects across the UAE.",
  image: heroImage,
  buttonText: "Request a Proposal",
  buttonOnclick: () =>
    openMailto({ subject: "Developer/Owner Proposal Request" }),
  footerText:
    "Our licensed technicians and 24/7 emergency response team are always ready to protect your home and business. ",
  footerButtonText: "Report an Emergency Online",
  footerButtonOnclick: () =>
    openMailto({
      subject: "Emergency Report",
      body: "Emergency Type:\nLocation:\nDescription:\n",
    }),
};

export default function DeveloperAndOwner() {
  return (
    <main className="bg-white ">
      {/* Hero section */}
      <section className="relative w-full overflow-hidden bg-[#D48C07]">
        <div className="relative mx-auto flex w-full max-w-[1728px] flex-col items-start gap-6 px-5 pb-10 pt-6 md:gap-10 md:px-10 md:pb-12 md:pt-8 lg:gap-20 lg:px-16 xl:gap-[145px] xl:px-[121px]">
          {/* Header */}
          <header className="relative z-10 w-full">
            <PartnerHeader />
          </header>

          <div className="flex items-center">
            {/* Hero Content */}
            <div className="z-[3] flex w-full max-w-full flex-col items-start gap-8 text-white md:gap-12 lg:max-w-[793px] lg:gap-20 xl:gap-[120px]">
              <div className="flex w-full flex-col items-start gap-6 md:gap-10 lg:gap-16">
                <div className="flex w-full flex-col items-start gap-4 md:gap-6">
                  <h1 className="text-[28px] lg:w-[900px] font-bold leading-[1.1] tracking-[-0.04em] sm:text-[35px] md:text-[48px] lg:text-[64px] xl:text-[76px]">
                    {heroData.title}
                  </h1>
                  <p className="text-[13px] leading-[1.4] tracking-[-0.04em] text-white/75 sm:text-xs md:text-base lg:text-[20px] xl:text-[24px]">
                    {heroData.description}
                  </p>
                </div>

                <div>
                  <HeroButton
                    onClick={heroData.buttonOnclick}
                    title={heroData.buttonText}
                  />
                </div>
              </div>

              <div className="flex w-fit max-w-full items-center gap-2.5 rounded-lg border border-white/40 bg-[#EFF0F317] p-3">
                <div
                  className="hidden size-[80px] flex-shrink-0 rounded-[6px] bg-white/10 md:flex md:size-[100px] lg:size-[120px] items-center justify-center"
                  aria-hidden="true"
                >
                  <img
                    src={emergencyIcon}
                    alt=""
                    className="w-10 h-10 lg:w-12 lg:h-12"
                  />
                </div>
                <div>
                  <p className="max-w-[380px] text-[13px] leading-snug sm:text-[14px] md:text-sm">
                    {heroData.footerText}
                  </p>
                  <button
                    onClick={heroData.footerButtonOnclick}
                    className="mt-2 flex items-center gap-2 border-b border-white text-[12px] transition-opacity hover:opacity-80 sm:text-xs md:mt-3 md:gap-2.5 md:text-base"
                    type="button"
                  >
                    {heroData.footerButtonText}
                    <img src={infoIcon} alt="" className="size-5 md:size-6" />
                  </button>
                </div>
              </div>
            </div>

            {/* Hero Image - Desktop */}
            <img
              src={heroData.image}
              alt="Hero illustration"
              className="hidden lg:block absolute top-[200px] xl:top-[168px] right-0 w-[450px] lg:w-[550px] xl:w-[677.7px] h-auto max-h-[1368px] z-[4]"
            />
          </div>
        </div>
      </section>

      {/* Our Turnkey Solutions for Developers & OAs */}
      <section className="pt-16 md:pt-16 lg:pt-24 xl:pt-[100px] bg-[#F1F1F1] px-4 md:px-6 lg:px-8 pb-16 md:pb-16 lg:pb-[120px]">
        <h1 className="text-[28px] md:text-[36px] lg:text-[48px] xl:text-[60px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
          Our Turnkey Solutions for Developers & OAs{" "}
        </h1>
        <h2 className="text-[#62636C] text-[16px] md:text-[20px] lg:text-[24px] xl:text-[28px] font-normal mt-3 md:mt-4 lg:mt-6 xl:mt-[28px] text-left md:text-center leading-relaxed">
          Our governance structure is based on four core pillars:
        </h2>

        <div className="mt-6 md:mt-8 lg:mt-12 xl:mt-16 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 lg:gap-8 max-w-[1400px] mx-auto">
          {serviceCards.map((card, index) => (
            <div
              key={index}
              className="w-full rounded-[16px] md:rounded-[20px] lg:rounded-[24px] min-h-[200px] md:min-h-[250px] lg:min-h-[300px] xl:min-h-[351px] bg-white p-4 md:p-5 lg:p-6 xl:p-[24px] flex flex-col"
            >
              <h1 className="text-[20px] md:text-[22px] lg:text-[26px] xl:text-[28px] font-semibold text-[#1C1C1C] leading-tight md:leading-normal">
                {card.title}
              </h1>

              {card.description && (
                <h2 className="text-[#0A0E2EBF] leading-relaxed text-[16px] md:text-[18px] lg:text-[18px] font-normal mt-2 md:mt-3">
                  {card.description}
                </h2>
              )}

              <div className="flex flex-col gap-2 md:gap-3 lg:gap-[12px] mt-3 md:mt-4 lg:mt-[16px]">
                {card.dataPoints.map((point, i) => (
                  <div key={i} className="flex items-start gap-2 md:gap-3">
                    <span className="min-w-[10px] min-h-[10px] md:min-w-[10px] md:min-h-[10px] lg:min-w-[12px] lg:min-h-[12px] rounded-full bg-[#62636C] mt-1.5 md:mt-2 flex-shrink-0"></span>
                    <h1 className="text-[16px] md:text-[16px] lg:text-[18px] text-[#0A0E2EBF] font-normal leading-relaxed lg:leading-[26px]">
                      {point}
                    </h1>
                  </div>
                ))}
                {card.footerNote && (
                  <p className="text-[#0A0E2EBF] leading-relaxed text-[16px] md:text-[16px] lg:text-[18px] font-normal mt-2 md:mt-3">
                    {card.footerNote}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/*           Benefits for Developers & Owners Associations{" "}
         */}
        <h1 className="text-[28px] md:text-[36px] lg:text-[48px] xl:text-[60px] mt-16 md:mt-16 lg:mt-24 xl:mt-[200px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
          Benefits for Developers & Owners Associations{" "}
        </h1>
        <BenefitsAccordion benefits={Benefits} />

        {/* Developer Project Lifecycle */}
        <div className="mx-auto max-w-[1400px]  mt-16 md:mt-16 lg:mt-24 xl:mt-[180px]">
          <h1 className="text-[28px] md:text-[36px] lg:text-[48px] xl:text-[60px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left ">
            Developer Project Lifecycle{" "}
          </h1>
          <h2 className="text-[#62636C] text-[16px] md:text-[20px] lg:text-[24px] xl:text-[28px] font-normal mt-3 md:mt-4 lg:mt-6 xl:mt-[28px] text-left  leading-relaxed">
            How GAZ Works with You{" "}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6 lg:gap-8 mt-6 md:mt-8 lg:mt-12 xl:mt-16 max-w-[1400px] mx-auto">
            {Lifecycles.map((data, i) => (
              <div
                key={i}
                className="bg-white p-4 md:p-5 lg:p-6 xl:p-[24px] w-full min-h-[190px] md:min-h-[200px] lg:min-h-[220px] rounded-[16px] md:rounded-[20px] lg:rounded-[24px]"
              >
                <h1 className="text-[20px] md:text-[22px] lg:text-[26px] xl:text-[28px] font-medium mt-2 md:mt-3 lg:mt-4 xl:mt-[16px]">
                  {data.title}{" "}
                </h1>
                <p className="text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] font-normal text-[#62636C] mt-2 md:mt-3">
                  {data.subtitle}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Solutions Tailored for Different Project Types */}

      <section className="mt-16 md:mt-16 lg:mt-24 xl:mt-[100px] px-4 md:px-6 lg:px-8">
        <div className="mx-auto max-w-[1400px]">
          <h1 className="text-[28px] w-full max-w-[828px] mx-auto md:text-[36px] lg:text-[48px] xl:text-[60px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
            Solutions Tailored for Different Project Types{" "}
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8 mt-6 md:mt-8 lg:mt-12 xl:mt-16 max-w-[1400px] mx-auto">
            {projectTypes.map((data, i) => (
              <div
                key={i}
                className="w-full min-h-[170px] md:min-h-[180px] lg:min-h-[190px] border border-[#62636C33] rounded-[16px] md:rounded-[20px] lg:rounded-[24px] p-4 md:p-5 lg:p-6 xl:p-[24px]"
              >
                <p className="text-[20px] md:text-[22px] lg:text-[24px] xl:text-[24px] text-[#1C1C1C] font-semibold leading-normal">
                  {data.title}
                </p>

                <div className="flex flex-col gap-1 md:gap-1.5 lg:gap-2 mt-2 md:mt-3">
                  {data.points.map((point, i) => (
                    <div
                      key={i}
                      className="flex items-start gap-2 md:gap-2.5 lg:gap-[8px]"
                    >
                      <span className="min-w-[10px] min-h-[10px] md:min-w-[10px] md:min-h-[10px] lg:min-w-[12px] lg:min-h-[12px] rounded-full bg-[#62636C] mt-1.5 md:mt-2 flex-shrink-0"></span>
                      <p className="text-[16px] md:text-[16px] lg:text-[18px] text-[#0A0E2EBF] leading-[24px] md:leading-[25px] lg:leading-[26px] font-normal">
                        {point}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Dedicated Relationship Management for Developers & OAs */}
      <section className="mt-16 md:mt-24 lg:mt-[180px] px-4 md:px-6 lg:px-8">
        <div className=" mx-auto max-w-[1400px]">
          <div className="flex flex-col lg:flex-row justify-center items-center gap-8 md:gap-12 lg:gap-16">
            <div className="flex-1 text-left md:text-center lg:text-left">
              <h1 className="text-[28px] w-full max-w-[753px] md:text-[36px] lg:text-[46px] font-semibold leading-normal text-[#122D63]">
                Dedicated Relationship Management for Developers & OAs{" "}
              </h1>
              <h2 className="text-[#62636C] text-[16px] md:text-[18px] lg:text-[24px] font-normal mt-4 leading-normal">
                We assign a Relationship Manager to every project:{" "}
              </h2>

              <div className="mt-4 md:mt-4 space-y-3 md:space-y-[12px]">
                {relationship.map((data, i) => (
                  <div
                    className="flex items-start md:items-center lg:justify-start gap-3 md:gap-4"
                    key={i}
                  >
                    <img
                      src={bulletPoint}
                      alt=""
                      className="flex-shrink-0 mt-1 md:mt-0"
                    />
                    <h3 className="text-[#62636C] text-[16px] md:text-[18px] lg:text-[24px] font-normal leading-normal">
                      {data}
                    </h3>
                  </div>
                ))}
              </div>
              <h2 className="text-[#62636C] text-[16px] md:text-[18px] lg:text-[24px] font-normal mt-4 md:mt-[18px] leading-normal">
                We assign a Relationship Manager to every project:{" "}
              </h2>
            </div>

            <div className="flex-1 flex justify-center w-full">
              <img
                src={relationshpImage}
                alt="Supplier Categories"
                className="w-full max-w-[500px] h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/*                 Sample Monthly Performance Report (Delivered to  */}

      <section className="mt-16 md:mt-16 pb-16 lg:mt-[100px] px-4 md:px-6 lg:px-8">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-[84px] xl:justify-between">
            {/* Text Content - First on mobile, Second on desktop */}
            <div className="flex-1 text-left md:text-center lg:text-left order-1 lg:order-2">
              <h1 className="text-[28px] w-full max-w-[753px] md:text-[36px] lg:text-[46px] font-semibold leading-normal text-[#122D63]">
                Sample Monthly Performance Report (Delivered to
                OAs/Developers){" "}
              </h1>
              <h2 className="text-[#62636C] text-[16px] md:text-[18px] lg:text-[24px] font-normal mt-4 leading-normal">
                Each month, we provide a detailed report including:{" "}
              </h2>
              <div className="mt-4 md:mt-4 space-y-3 md:space-y-[12px]">
                {performances.map((data, i) => (
                  <div
                    className="flex items-start md:items-center lg:justify-start gap-3 md:gap-4"
                    key={i}
                  >
                    <img
                      src={bulletPoint}
                      alt=""
                      className="flex-shrink-0 mt-1 md:mt-0"
                    />
                    <h3 className="text-[#62636C] text-[16px] md:text-[18px] lg:text-[24px] font-normal leading-normal">
                      {data}
                    </h3>
                  </div>
                ))}
              </div>
            </div>

            {/* Image - Second on mobile, First on desktop (left side) */}
            <div className="w-full lg:max-w-[647px] aspect-[647/552] pt-8 md:pt-10 lg:pt-12 xl:pt-[67px] pl-4 md:pl-5 lg:pl-6 xl:pl-[35px] rounded-[16px] md:rounded-[20px] lg:rounded-[24px] bg-[#F24D2B] flex items-start justify-start overflow-hidden order-2 lg:order-1">
              <img
                src={macbook}
                alt=""
                className="w-full h-full object-contain object-left-top"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="pt-16 md:pt-16 lg:pt-24 xl:pt-[100px] bg-[#F1F1F1] px-4 md:px-6 lg:px-8 pb-16 md:pb-16 lg:pb-[120px]">
        <div className="mx-auto max-w-[1400px] ">
          <h1 className="text-[28px] md:text-[36px] lg:text-[48px] xl:text-[60px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
            Developer Toolkit{" "}
          </h1>
          <h2 className="text-[#62636C] text-[16px] md:text-[20px] lg:text-[24px] xl:text-[28px] font-normal mt-3 md:mt-4 lg:mt-6 xl:mt-[28px] text-left md:text-center leading-relaxed">
            Access our official developer toolkits{" "}
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 mt-6 md:mt-8 lg:mt-12 xl:mt-16">
            {developerToolkit.map((tool, i) => (
              <div
                key={i}
                className="w-full flex gap-3 md:gap-4 lg:gap-6 items-center min-h-[80px] md:min-h-[100px] lg:min-h-[112px] bg-white rounded-[12px] md:rounded-[16px] px-3 md:px-4 lg:px-6 py-4 md:py-6"
              >
                <div className="size-[40px] md:size-[56px] lg:size-[64px] rounded-[8px] md:rounded-[12px] bg-[#F1F1F1] flex items-center justify-center flex-shrink-0">
                  <img
                    src={documentIcon}
                    alt=""
                    className="w-5 h-5 md:w-7 md:h-7 lg:w-8 lg:h-8"
                  />
                </div>
                <p className="text-[16px] md:text-[22px] lg:text-[28px] text-[#1E1F24] font-medium flex-1 leading-tight min-w-0">
                  {tool.title}
                </p>
                <button className="size-[36px] md:size-[48px] lg:size-[56px] rounded-full border border-[#F1F1F1] flex items-center justify-center flex-shrink-0">
                  <img
                    src={downloadIcon}
                    alt=""
                    className="w-4 h-4 md:w-6 md:h-6"
                  />
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pt-16 bg-[#F1F1F1] px-4 md:px-6 lg:px-8 pb-16 md:pb-16 lg:pb-[120px]">
        <div className="mx-auto max-w-[1400px] ">
          <h1 className="text-[28px] md:text-[36px] lg:text-[48px] xl:text-[60px] font-semibold leading-tight md:leading-normal text-[#122D63] text-left md:text-center">
            Request a Proposal{" "}
          </h1>

          <RequestProposalForm />
        </div>{" "}
      </section>

      {/* Contact Section */}
      <div className="mx-auto py-12 md:py-16 lg:py-20 xl:py-[100px] px-4 md:px-6 lg:px-8">
        <Contact
          title="Need Help with your Bill or Account"
          subtitle="Call our 24/7 Emergency Line: 800-GAZ (42747) or report a concern via our Online Safety Form."
          cardTitle="Book Consultation"
          contactDetails={[
            { title: "help@gazglobal.net", icon: mailIcon },
            { title: "Support (8 AM – 8 PM)", icon: phoneIcon },
            { title: "Sunday – Thursday (8 AM – 6 PM)", icon: buildingIcon },
          ]}
        />
      </div>
    </main>
  );
}
